import { render } from "./App.vue?vue&type=template&id=c2185304"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c2185304&lang=css"

import exportComponent from "/var/www/display-measurement-prd-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__